import PageBody from "../PageBody";
import NotificationTypes from "../components/pages/notifications/NotificationTypes";

const NotificationTypesPage = () => {
  return (
    <PageBody>
      <NotificationTypes />
    </PageBody>
  );
};

export default NotificationTypesPage;
